
import { Link } from "react-router-dom";

export const ConnectedRepositoriesSection = () => {
  return (
    <section className="py-24 bg-background relative">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/8),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top,theme(colors.brand.orange/4),transparent)]" />
        <div className="absolute inset-0 bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/5),transparent)] dark:bg-[radial-gradient(45rem_50rem_at_top_right,theme(colors.brand.blue/3),transparent)]" />
      </div>

      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-8 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange">
            Skillengers : Tous les répertoires, enfin connectés
          </h2>
          
          <p className="text-lg text-muted-foreground mb-12">
            Avec Skillengers, vous n'avez plus besoin de chercher dans chaque répertoire séparément. 
            Notre moteur de recherche connecte tous ces répertoires et traduit automatiquement les métiers et compétences entre eux.
          </p>
          
          <div className="grid sm:grid-cols-3 gap-8">
            <FeatureCard text="Recherchez un métier ou une compétence et obtenez des résultats consolidés." />
            <FeatureCard text="Gagnez du temps en naviguant facilement à travers les systèmes RH complexes." />
            <FeatureCard text="Visualisez votre parcours professionnel ou les besoins de votre organisation en un seul clic." />
          </div>
        </div>
      </div>
    </section>
  );
};

const FeatureCard = ({ text }: { text: string }) => (
  <div className="group bg-card p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-border">
    <p className="text-muted-foreground flex items-start gap-3">
      <span className="w-2 h-2 mt-2 rounded-full bg-gradient-to-r from-brand-orange to-brand-blue flex-shrink-0 group-hover:scale-125 transition-transform duration-300" />
      {text}
    </p>
  </div>
);
